import axios from 'axios';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import Select from 'react-select';
import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import Swal from 'sweetalert2'; // Make sure to import SweetAlert
import 'react-datepicker/dist/react-datepicker.css';
import { baseurl } from '../utility/helper';

const TestReports = () => {
    const roleid = parseInt(sessionStorage.getItem("userroleId"));
    const initialChapter = roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : "";
    const [chapters, setChapters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        chapterId: '',
        testId: '',
        test_start_date: null,
        test_end_date: null,
        selectedFields: []
    });
    const [filteredData, setFilteredData] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [noData, setNoData] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);
    const tableRef = useRef(null);

    const exclusiveFilters = [
    'result_pending',
    'active_test',
    'completed_test',
    'cancel_test',
    ];


    const fieldOptions = [
        { value: 'chapter', label: 'Chapter' },
        // { value: 'status', label: 'Membership Status' }, 
        { value: 'date', label: 'Test Date' },
        { value: 'result_pending', label: 'Result Pending' },
        { value: 'active_test', label: 'Active Test' },
        { value: 'completed_test', label: 'Completed Test' },
        { value: 'cancel_test', label: 'Cancelled Test' },
    ];

    useEffect(() => {
        const fetchChapters = async () => {
        try {
            const response = await axios.get(`${baseurl}/admin/chapters`);
            setChapters(response.data); // Store API data in 'chapters'
        } catch (error) {
            console.error("Error fetching chapters:", error);
        }
        };

        fetchChapters();
    }, []);

    const formatDate = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
    };

    const fetchData = async (filters) => {
        try {
            const queryParams = new URLSearchParams();

            // Chapter validation for roleid 2
            if (roleid === 2 && !initialChapter) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Chapter Missing',
                    text: 'Please select a chapter before fetching data.',
                });
                return []; // Exit if chapter is missing
            }

            // Existing filters
            if (filters.chapterId) queryParams.append('chapter_id', filters.chapterId);
            if (filters.membershipStatus) queryParams.append('membershipStatus', filters.membershipStatus);
            if (filters.test_start_date) queryParams.append('test_start_date', formatDate(filters.test_start_date));
            if (filters.test_end_date) queryParams.append('test_end_date', formatDate(filters.test_end_date));

            // Direct value filters
            if (filters.active_test ) queryParams.append('active_test', filters.active_test);
            if (filters.cancel_test ) queryParams.append('cancel_test', filters.cancel_test);
            if (filters.result_pending ) queryParams.append('result_pending', filters.result_pending);
            
            if (filters.completed_test ) queryParams.append('completed_test', filters.completed_test);
            if (filters.Result) queryParams.append('Result', filters.Result);

            const response = await axios.get(`${baseurl}/admin/Testfiltered?${queryParams.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            return [];
        }
    };


    const formatDateTime = (timestamp) => {
        const date = new Date(timestamp);
        const day = date.getDate();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        let hours = date.getHours(); // Use getHours for local time
        const minutes = String(date.getMinutes()).padStart(2, '0');

        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;

        const formattedTime = `${hours}:${minutes} ${ampm}`;

        return `${day}-${month}-${year} ${formattedTime}`;
    };

    useEffect(() => {
        if (hasSearched) {
            if (showTable) {
                const dataTable = $(tableRef.current).DataTable({
                    destroy: true,
                    dom: 'Blfrtip',
                    pageLength: 25,
                    lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
                    buttons: [
                        { extend: 'colvis', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', columns: ':visible' },
                        { extend: 'copyHtml5', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', exportOptions: { columns: ':visible' } },
                        { extend: 'excelHtml5', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', exportOptions: { columns: ':visible' } },
                        { extend: 'csvHtml5', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', exportOptions: { columns: ':visible' } },
                        { extend: 'pdfHtml5', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', exportOptions: { columns: ':visible' } },
                        { extend: 'print', className: 'btn btn-primary glyphicon glyphicon-duplicate dttable', exportOptions: { columns: ':visible' } }
                    ],
                    data: filteredData,
                    columns: [
                        {
                            title: 'Test No',
                            data: 'test_id',
                            render: (data, type, row) =>
                                type !== 'display'
                                    ? (data ?? '')
                                    : `<a href="/admin/EditTest?testId=${data}&ChapterID=${row.chapter_id}" onclick="event.preventDefault(); window.open(this.href, '_blank');">${data ?? ''}</a>`,
                        },
                        { title: 'Chapter ID', data: 'chapter_id' },
                        { title: 'Chapter Name', data: 'chapter_name' },
                        { title: 'Test Name', data: 'test_title' },
                        { title: 'Test Desc', data: 'test_desc' },
                        { title: 'Address', data: 'venue' },
                        { title: 'Note', data: 'note' },
                        {
                            title: 'Register Start',
                            data: 'register_start_date',
                            render: function (data) {
                                return formatDateTime(data);
                            }
                        },
                        {
                            title: 'Register End',
                            data: 'register_end_date',
                            render: function (data) {
                                return formatDateTime(data);
                            }
                        },
                        {
                            title: 'Test Start',
                            data: 'test_start_time',
                            render: function (data) {
                                return formatDateTime(data);
                            }
                        },
                        {
                            title: 'Test End',
                            data: 'test_end_time',
                            render: function (data) {
                                return formatDateTime(data);
                            }
                        }

                    ],
                    initComplete: function () {
                        $('.dt-length select').addClass('form-select form-select-sm');
                    }
                });
                $('.dt-buttons .dttable').css('z-index', 0);

                $('#reports').on('click', '.edit-btn', function () {
                    const id = $(this).data('id');
                    handleEdit(id);
                });

                $('#reports').on('click', '.delete-btn', function () {
                    const id = $(this).data('id');
                    handleDelete(id);
                });
            } else {
                setNoData(true);
                setShowTable(false);

            }
        }

        return () => {
            if ($.fn.DataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable().destroy(false);
            }
        };
    }, [hasSearched, showTable, filteredData]);

    const handleFieldSelection = (selectedOptions) => {
    const selectedValues = selectedOptions.map(option => option.value);
    const today = new Date();

    const updatedFilters = {
        ...filters,
        selectedFields: selectedValues,
        // Remove values of unselected fields
        chapterId: selectedValues.includes('chapter') ? filters.chapterId : '',
        membershipStatus: selectedValues.includes('status') ? filters.membershipStatus : '',
        active_test: selectedValues.includes('active_test') ? 1 : '',
        cancel_test: selectedValues.includes('cancel_test') ? 1 : '',
        result_pending: selectedValues.includes('result_pending') ? 1 : '',
        completed_test: selectedValues.includes('completed_test') ? 1 : '',
        joinDateStart: null,
        joinDateEnd: null,
        test_start_date: null,
        test_end_date: null
    };

    setFilters(updatedFilters);
    };

    const handleEdit = (id) => {
        console.log('Edit button clicked for ID:', id);
        // Handle edit action here
    };

    const handleDelete = (id) => {
        console.log('Delete button clicked for ID:', id);
        // Handle delete action here
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters({
            ...filters,
            [name]: value
        });
    };

    const handleDateChange = (dates) => {
        const [start, end] = dates;
        setFilters({
            ...filters,
            test_start_date: start,
            test_end_date: end
        });
    };

    const handleSearch = async () => {
        setLoading(true);

        // Show loading modal while fetching data
        Swal.fire({
            title: 'Searching...',
            text: 'Please wait while we fetch the report data.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const data = await fetchData(filters);
            setFilteredData(data);
            setNoData(data.length === 0);
            setShowTable(data.length > 0);
            setHasSearched(true);
        } finally {
            setLoading(false);
            Swal.close();
        }
    };

    return (
        // <div className="page-wrapper">
        <div className="container mt-4">
            <div className="profile-section">
                <h2 style={{ textAlign: 'center' }}>Test Report</h2>
                 {/* Filters Section */}
                 <div className="row g-3">
                    <div className="col-md-12">
                        <label className="form-label">Select Fields:</label>
                        <Select
                          isMulti
                          options={fieldOptions}
                          value={fieldOptions.filter(opt => filters.selectedFields.includes(opt.value))}
                          onChange={handleFieldSelection}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          isOptionDisabled={(option) => {
                            // If an exclusive filter is already chosen, disable all other exclusive filters
                            const alreadySelected = filters.selectedFields.find(v => exclusiveFilters.includes(v));
                            return alreadySelected && exclusiveFilters.includes(option.value) && !filters.selectedFields.includes(option.value);
                          }}
                        />
                    </div>

                    {filters.selectedFields.includes('chapter') && (
                        <div className="col-md-4">
                            <label className="form-label">Chapter ID:</label>
                            <select
                                className="form-select"
                                name="chapterId"
                                value={filters.chapterId}
                                onChange={handleFilterChange}
                                >
                                <option value="" disabled>-- Select Chapter --</option>
                                {chapters.filter(term => term.chapter_id !== 1) // Exclude chapter_id = 1
                                    .map((term) => (
                                        <option key={term.chapter_id} value={term.chapter_id}>
                                        {term.chapter_name}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    )}

                    {filters.selectedFields.includes('status') && (
                        <div className="col-md-4">
                            <label className="form-label">Membership Status:</label>
                            <input
                                type="text"
                                className="form-control"
                                name="membershipStatus"
                                value={filters.membershipStatus}
                                onChange={handleFilterChange}
                            />
                        </div>
                    )}
                    {filters.selectedFields.includes('date') && (
                    <>
                        <div className="col-md-4">
                        <label className="form-label">Start Date:</label>
                        <DatePicker
                            selected={filters.test_start_date}
                            onChange={(date) =>
                            setFilters((prev) => ({
                                ...prev,
                                test_start_date: date,
                                test_end_date: null, // reset end date when start changes
                            }))
                            }
                            dateFormat="dd-MM-yyyy"
                            className="form-control"
                            placeholderText="Select start date"
                        />
                        </div>

                        <div className="col-md-4">
                        <label className="form-label">End Date:</label>
                        <DatePicker
                            selected={filters.test_end_date}
                            onChange={(date) =>
                            setFilters((prev) => ({ ...prev, test_end_date: date }))
                            }
                            dateFormat="dd-MM-yyyy"
                            className="form-control"
                            placeholderText="Select end date"
                            minDate={filters.test_start_date} // prevent selecting before start date
                            disabled={!filters.test_start_date} // disable until start date is selected
                        />
                        </div>
                    </>
                    )}

                    <div className="col-12 text-center">
                        <button className="mt-3" style={{ borderRadius: '8px' }} onClick={handleSearch} disabled={loading}>
                          {loading ? 'Loading...' : 'Search'}
                        </button>
                    </div>
                </div>
                {/* Table Section */}
                <hr />
                {!hasSearched ? (
                    <h1 style={{ textAlign: 'center' }}>Please perform a search to view data.</h1>
                ) : noData ? (
                    <h1 style={{ textAlign: 'center' }}>No Data Available</h1>
                ) : (
                    <div className="table-container" style={{ overflowX: 'auto' }}>
                        <table id="reports" className="table table-striped table-bordered" ref={tableRef} style={{ overflowX: 'scroll' }}>

                        </table>
                    </div>
                )}
            </div>
        </div>
        // </div>
    );
};

export default TestReports;